import { Icon, Tooltip, TooltipProps } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { AccountingBasis } from '@modules-deprecated/app/organization/types/accountingBasis'

type GraphInfoTooltipProps = Omit<TooltipProps, 'label' | 'children'>

export const GraphInfoTooltip = (props: GraphInfoTooltipProps): ReactElement => {
  const { organization } = useUserOrganization()
  const { t } = useTranslation()

  const tooltipLabel = useMemo(() => {
    if (organization?.accountingBasis === AccountingBasis.Cash) {
      return t('dashboard.widget.graph.info.cash')
    }

    return t('dashboard.widget.graph.info.accrual')
  }, [organization?.accountingBasis, t])

  return (
    <Tooltip {...props} label={tooltipLabel}>
      <Icon icon="info" />
    </Tooltip>
  )
}
